import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { routes as crmRoutes } from './crm/routes.js';
import { routes as agendaRoutes } from './agenda/routes.js';
import { routes as capacityAgendaRoutes } from './capacityAgenda/routes.js';
import { routes as medicalRecordRoutes } from './medicalRecord/routes.js';
import { routes as managementChartsRoutes } from './managementCharts/routes.js';
import { routes as manuaisRoutes } from './manuais/routes.js';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';

const AppContainer = () => import('./Dashboard.vue');
const Captain = () => import('./Captain.vue');
const Suspended = () => import('./suspended/Index.vue');

export default {
  routes: [
    ...helpcenterRoutes.routes,
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        {
          path: frontendURL('accounts/:accountId/captain'),
          name: 'captain',
          component: Captain,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...crmRoutes,
        ...agendaRoutes,
        ...capacityAgendaRoutes,
        ...medicalRecordRoutes,
        ...managementChartsRoutes,
        ...manuaisRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: [
          'administrator',
          'agent',
          'doctor',
          'manager',
          'custom_role',
        ],
      },
      component: Suspended,
    },
  ],
};
